import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { SnCamera } from '@lib/api/entities';
import { FsMapPresenceDevicesServiceProvider, IFsMap, DevicesResponse } from '@lib/geo/core';

@Injectable()
export class MapPresenceDevicesFacadeService<
  TMap extends IFsMap,
  TMarker,
  TDevice,
> extends FsMapPresenceDevicesServiceProvider<TMap, TMarker, TDevice> {
  constructor(
    private readonly _provider: FsMapPresenceDevicesServiceProvider<TMap, TMarker, TDevice>,
  ) {
    super();
  }

  // Streams
  public get dock$(): Observable<TMarker> {
    return this._provider.dock$;
  }

  public get dockNearbyCameras$(): Observable<SnCamera> {
    return this._provider.dockNearbyCameras$;
  }

  public get hovered$(): Observable<TMarker> {
    return this._provider.hovered$;
  }

  public get mouseOut$(): Observable<void> {
    return this._provider.mouseOut$;
  }

  // Data
  public get advancedMarkers(): TMarker[] {
    return this._provider.advancedMarkers;
  }

  // Lifecycle
  public onMapLoaded(map: TMap): void {
    this._provider.onMapLoaded(map);
  }

  public addToMap(): void {
    this._provider.addToMap();
  }

  public removeFromMap(): void {
    this._provider.removeFromMap();
  }

  // Actions
  public viewOnMap(marker: TMarker): void {
    this._provider.viewOnMap(marker);
  }

  public findMarkerAndSelect(marker: TMarker): void {
    this._provider.findMarkerAndSelect(marker);
  }

  public deselect(marker: TMarker): void {
    this._provider.deselect(marker);
  }

  public openDeviceHistory(marker: TMarker): void {
    this._provider.openDeviceHistory(marker);
  }

  public dockStream(device: TMarker): void {
    this._provider.dockStream(device);
  }

  public setupListeners(): void {
    this._provider.setupListeners();
  }

  public selectMarkerByDeviceId$(deviceId: string) {
    return this._provider.selectMarkerByDeviceId$(deviceId);
  }

  // Data fetcher (shadow mode)
  // Use any here because PresenceDevicesResponse is an internal type of the provider.
  public getDevicesForShadowMode(
    bbox: string[],
    zoom?: number,
  ): Observable<DevicesResponse<TDevice>> {
    return this._provider.getDevicesForShadowMode(bbox, zoom);
  }
}
